let dynamicByUserId: Record<number, string> = {}
let dynamicBySegment: Record<string, string> = {}

/** Default segment to fall back to when a user has no dedicated PID. */
export const DEFAULT_CJ_WEBSITE_SEGMENT = { website: '7127090' }

/** Keeps non-React code (e.g. `generateTrackingLink`) aligned with context after API fetch. */
export const setCjPidsRegistry = (params: {
  byUserId: Record<number, string>
  bySegment: Record<string, string>
}) => {
  dynamicByUserId = { ...params.byUserId }
  dynamicBySegment = { ...params.bySegment }
}

export const clearCjPidsRegistry = () => {
  dynamicByUserId = {}
  dynamicBySegment = {}
}

export const getCommissionJunctionPidForUserId = (
  userId: number
): string | undefined =>
  dynamicByUserId[userId] ?? DEFAULT_CJ_WEBSITE_SEGMENT.website

export const getCommissionJunctionPidForSegment = (
  segment: string
): string | undefined => dynamicBySegment[segment]

/**
 * Resolution order for CJ deep-link PID:
 * 1. User-dedicated PID (API or static fallback)
 * 2. Segment PID (e.g. `'website'`) from API
 */
export const resolveCommissionJunctionPid = (
  userId: number | undefined
): string | undefined => {
  let dedicatedPid = undefined
  if (userId != null && Number.isFinite(userId)) {
    dedicatedPid = getCommissionJunctionPidForUserId(userId)
  }
  dedicatedPid = getCommissionJunctionPidForSegment(
    Object.keys(DEFAULT_CJ_WEBSITE_SEGMENT)[0]
  )
  return dedicatedPid ?? DEFAULT_CJ_WEBSITE_SEGMENT.website
}
